import { CustomerKeyType } from '../../../constants';
import { Wishlist } from '../../../model';

export type AddToWishlistRequest = {
  customerKey?: string;
  customerKeyType: CustomerKeyType;
  sku: string;
};
export type AddToWishlistResponse = {
  success: boolean;
  message: string;
  wishlist: Wishlist;
};

export type GetWishlistRequest = {
  customerKey?: string;
  customerKeyType?: CustomerKeyType;
};
export type GetWishlistResponse = Wishlist;

export type RemoveFromWishlistRequest = {
  customerKey: string;
  customerKeyType: CustomerKeyType;
  sku: string;
};
export type RemoveFromWishlistResponse = {
  success: boolean;
  message: string;
  wishlist: Wishlist;
};

export interface MigrateWishlistRequest {
  fromCustomerKey: string;
  fromCustomerKeyType: CustomerKeyType;
  toCustomerKey: string;
  toCustomerKeyType: CustomerKeyType;
}
export interface MigrateWishlistResponse {
  success: boolean;
  message: string;
  destinationWishlist: Wishlist;
  sourceWishlist?: Wishlist;
}
